// Mirrors server/src/utils/arn.ts. ARN is a 1–6 digit AMFI distributor
// identifier; users may type '123456' or 'ARN-123456', always normalized to
// the bare digit string.
const ARN_INPUT_PATTERN = /^(?:ARN[-\s]?)?(\d{1,6})$/i;

// System-generated client code for NON-ARN clients (NA00001); passes through
// normalizeArn unchanged so shared code paths accept both key types.
const NON_ARN_CODE_PATTERN = /^NA\d{5,10}$/i;

export const isNonArnCode = (raw: string): boolean => NON_ARN_CODE_PATTERN.test(raw.trim());

export const normalizeArn = (raw: string): string | null => {
  const trimmed = raw.trim();
  if (isNonArnCode(trimmed)) return trimmed.toUpperCase();
  const match = ARN_INPUT_PATTERN.exec(trimmed);
  return match ? match[1] : null;
};
